import {queryToObject} from './queryParams'

export const isEmbedded = queryToObject(document.location.search)?.embedded
